import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './Label.module.css';

const Label = ({ value, tooltip, id, bold = true }) => {
    return (
        <div id={id ? id : ''} className={`${styles.labelContainer} ${bold ? styles.bold : ''}`}>
            {value}
            {tooltip && (
                <Tooltip title={tooltip} arrow={true} classes={{ tooltip: 'generic-tooltip' }} placement="right">
                    <div className="moreInfoIcon" />
                </Tooltip>
            )}
        </div>
    );
};

export default React.memo(Label);
